module.exports = __webpack_public_path__ + "img/injuryTypes.34bc835a.svg";